<template>
  <div class="screen-time-management-day-picker"
       :class="dayPickerStyles">
    <div class="day"
         :class="getDayClasses(day, index)"
         v-for="(day, index) in timeLimits"
         :key="day.name"
         @click="toggleDay(day)">
      <div class="day-container">
        <div class="day-name">
          {{ day.name }}
        </div>
        <div class="day-limit">
          {{ day.limit }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { getDayNameByIndex } from '@/services/intl'

  export default {
    props: {
      timeLimits: {
        required: true,
        type: Array
      }
    },

    computed: {
      dayPickerStyles() {
        return {
          'screen-time-management-day-picker-mobile': this.$mq === 'mobile'
        }
      }
    },

    methods: {
      toggleDay(selectedDay) {
        if (this.timeLimits.every(day => !day.selected || day === selectedDay)) {
          return
        }

        this.$emit('toggle', selectedDay)
      },

      getDayClasses(day, index) {
        let previousDay = this.timeLimits[index - 1]
        let nextDay = this.timeLimits[index + 1]

        return {
          'selected': day.selected,
          'current': day.name === getDayNameByIndex(),
          'connect-right': nextDay && nextDay.selected,
          'connect-left': previousDay && previousDay.selected
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .screen-time-management-day-picker {
    display: flex;
  }

  .day {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 58px;
    height: 58px;
    color: #3e3a3b;
    border-radius: 50%;
    cursor: pointer;
    transition: all .1s ease-out;
    user-select: none;

    &.selected {
      background-color: map.get($colors, secondary);
    }

    &.current {
      color: map.get($colors, primary);
    }

    &.connect-right {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }

    &.connect-left {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }

  .day-container {
    text-align: center;
  }

  .day-name {
    font-size: 16px;
    font-weight: bold;
  }

  .day-limit {
    font-size: 12px;
  }

  .screen-time-management-day-picker-mobile {
    .day {
      width: 48px;
      height: 48px;

      .day-name {
        font-size: 14px;
      }
    }
  }
</style>
